import React from 'react';
import { number } from 'prop-types';
import CartIcon from 'dibs-vg/dist/react/cart-open';

import copy from '../../../../../json/copy/pdp.json';
import style from './styles/Urgency.scss';

const Urgency = (props) => (
    <div className={style.container}>
        <CartIcon className={style.icon} />

        <div className={style.content}>
            <div className={style.title}>{copy.urgency.title}</div>
            <div className={style.text}>{props.views} {copy.urgency.text}</div>
        </div>
    </div>
);

Urgency.propTypes = {
    views: number.isRequired
};

export default Urgency;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/Urgency.jsx